import React, { useContext, useState, useEffect } from 'react';
import { UserContext } from '../../context/UserContext';
import { Button } from '@progress/kendo-react-buttons';

export default function RefreshSettingsButton() {
  const { features, configVersion } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    const checkForUpdates = async () => {
      try {
        const response = await fetch('/settings');
        if (response.ok) {
          const freshSettings = await response.json();

          // Sentinel change is the primary signal for an update
          const sentinelChanged =
            configVersion !== (freshSettings?.configVersion ?? '');

          // Also watch for feature flag or environment drift as fallback
          const featuresChanged =
            JSON.stringify(features) !==
            JSON.stringify(freshSettings?.features ?? {});

          setUpdateAvailable(sentinelChanged || featuresChanged);
        }
      } catch (error) {
        console.error('Error checking for updates:', error);
      }
    };

    // Check every 30 seconds to match the backend Sentinel polling interval
    const interval = setInterval(checkForUpdates, 30000);

    // Check immediately on mount
    checkForUpdates();

    return () => clearInterval(interval);
  }, [features, configVersion]);

  const handleRefresh = async () => {
    setIsLoading(true);
    try {
      // Full page reload to pick up any frontend code changes
      window.location.reload();
    } catch (error) {
      console.error('Error reloading:', error);
      setIsLoading(false);
    }
  };

  if (!updateAvailable) {
    return null;
  }

  return (
    <Button
      onClick={handleRefresh}
      disabled={isLoading}
      title="Updates available. Click to reload and apply changes."
      className="button--refresh"
      themeColor="warning"
    >
      Updates Available
    </Button>
  );
}
